import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询打印配置列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getFeePrintSpecList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feePrintSpec/queryFeePrintSpec',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增打印配置
 * @param {Object} data 新增数据
 * @returns {Promise} Promise对象
 */
export function saveFeePrintSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feePrintSpec/saveFeePrintSpec',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改打印配置
 * @param {Object} data 修改数据
 * @returns {Promise} Promise对象
 */
export function updateFeePrintSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feePrintSpec/updateFeePrintSpec',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除打印配置
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteFeePrintSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feePrintSpec/deleteFeePrintSpec',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}